<template>
  <div class="storyshop">
    <!-- 全局头部导航（与首页/笔记页一致） -->
    <header-nav></header-nav>

    <div class="shop-layout">
      <!-- ===== 左侧栏（占 1/4）：店名 → 星裙币 → 空白 → 当前时间 ===== -->
      <aside class="shop-sidebar">
        <!-- 区域1：小店名称/标题 -->
        <div class="side-block side-title">
          <div class="shop-badge">✦ 星物语小店 ✦</div>
          <h1 class="shop-name">喜欢的小物品<br>带回家</h1>
          <p class="shop-slogan">洛丽塔 · JK · 汉服 · 配饰 · 袜子 · 高跟鞋</p>
        </div>

        <!-- 区域2：星裙币数量 -->
        <div class="side-block side-coin">
          <div class="coin-title">我的星裙币</div>
          <div class="coin-num" v-if="user && user.no">💠 {{ coin }}</div>
          <div class="coin-login" v-else>
            <el-button type="primary" size="small" round @click="openLoginTip">请先登录</el-button>
<!--            <p class="coin-tip">普通用户 1000 / 管理员 2000 / 超管 10000</p>-->
          </div>
          <div class="coin-user" v-if="user && user.no">{{ user.name }} · {{ roleName }}</div>
        </div>

        <!-- 区域3：空白占位 -->
        <div class="side-block side-spacer"></div>

        <!-- 区域4：当前时间 -->
        <div class="side-block side-clock">
          <div class="clock-time">{{ now }}</div>
          <div class="clock-date">{{ today }} · {{ week }}</div>
        </div>
      </aside>

      <!-- ===== 右侧栏（占 3/4）：商品列表，独立内部滚动 ===== -->
      <main class="shop-main">
        <div class="main-head">
          <el-tabs v-model="activeCategory" class="category-tabs" @tab-click="loadProducts">
            <el-tab-pane label="全部" name="全部"></el-tab-pane>
            <el-tab-pane v-for="c in categories" :key="c.name" :label="c.name" :name="c.name"></el-tab-pane>
          </el-tabs>
          <span class="product-count">共 {{ products.length }} 件</span>
        </div>

        <!-- 商品滚动区 -->
        <div class="product-scroll" v-loading="loading">
          <div class="product-grid">
            <div class="product-card" v-for="(p, idx) in products" :key="p.id">
              <div class="product-img-wrap" @click="openPreview(idx)">
                <img class="product-img" :src="imgUrl(p.image)" :alt="p.name" @error="imgErr">
                <span class="category-tag">{{ p.category }}</span>
                <div class="img-mask"><span>🔍 细节预览</span></div>
              </div>
              <div class="product-info">
                <h3 class="product-name">{{ p.name }}</h3>
                <p class="product-desc">{{ p.description }}</p>
                <div class="product-bottom">
                  <span class="price" v-if="isOnSale(p)">
                    <b>💠</b>
                    <i class="price-origin">￥{{ p.price }}</i>
                    <b class="price-now">{{ finalPrice(p) }}</b>
<!--                    <i>星裙币</i>-->
                    <span class="sale-tag">{{ p.discount }}折</span>
                  </span>
                  <span class="price" v-else><b>💠</b>{{ p.price }} </span>
                  <el-button type="primary" size="small" round @click="addToCart(p)">购买</el-button>
                </div>
              </div>
            </div>
            <div class="empty-tip" v-if="!loading && products.length === 0">该分类下暂时没有商品～</div>
          </div>
        </div>
      </main>
    </div>

    <!-- 悬浮购物车入口 -->
    <div class="cart-fab" @click="cartVisible = true">
      <span class="fab-icon">🛍️</span>
      <span class="fab-count" v-if="cartCount > 0">{{ cartCount }}</span>
      <span class="fab-text">购物车</span>
    </div>

    <!-- 图片放大预览 -->
    <el-dialog
        :visible.sync="previewVisible"
        width="520px"
        :with-header="false"
        custom-class="preview-dialog"
        :close-on-click-modal="true"
        @closed="previewVisible = false">
      <div class="preview-box" v-if="previewProduct">
        <div class="preview-img-wrap">
          <img class="preview-img" :src="imgUrl(previewProduct.image)" :alt="previewProduct.name">
          <div class="preview-nav prev" @click.stop="prevImg" :class="{ disabled: previewIndex <= 0 }">‹</div>
          <div class="preview-nav next" @click.stop="nextImg" :class="{ disabled: previewIndex >= products.length - 1 }">›</div>
        </div>
        <div class="preview-info">
          <h3>{{ previewProduct.name }}</h3>
          <p>{{ previewProduct.description }}</p>
          <span class="preview-price" v-if="isOnSale(previewProduct)">
            💠 {{ finalPrice(previewProduct) }} 星裙币
            <i class="price-origin">原价 {{ previewProduct.price }}</i>
            <span class="sale-tag">{{ previewProduct.discount }}折</span>
          </span>
          <span class="preview-price" v-else>💠 {{ previewProduct.price }} 星裙币</span>
          <span class="preview-cat">{{ previewProduct.category }}</span>
        </div>
      </div>
    </el-dialog>

    <!-- 购物车 / 消费记录 抽屉 -->
    <el-drawer
        :visible.sync="cartVisible"
        direction="rtl"
        size="420px"
        :with-header="false"
        custom-class="shop-drawer"
        :modal-append-to-body="false">
      <div class="drawer-inner">
        <el-tabs v-model="cartTab" class="shop-tabs">
          <!-- 购物车 -->
          <el-tab-pane label="购物车" name="cart">
            <div class="cart-list" v-if="cart.length > 0">
              <div class="cart-item" v-for="(item, idx) in cart" :key="item.id">
                <img class="cart-img" :src="imgUrl(item.image)" :alt="item.name">
                <div class="cart-info">
                  <div class="cart-name">{{ item.name }}</div>
                  <div class="cart-price" v-if="isOnSale(item)">
                    💠{{ itemFinalPrice(item) }}
                    <i class="price-origin">原价 {{ item.price }}</i>
                    <span class="sale-tag">{{ item.discount }}折</span>
                  </div>
                  <div class="cart-price" v-else>💠{{ item.price }}</div>
                  <div class="cart-ctrl">
                    <el-button size="mini" circle @click="changeCount(idx, -1)">−</el-button>
                    <span class="cart-count">{{ item.count }}</span>
                    <el-button size="mini" circle @click="changeCount(idx, 1)">＋</el-button>
                    <el-button size="mini" type="danger" plain class="cart-remove" @click="removeItem(idx)">删除</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="cart-empty" v-else>
              <div class="empty-icon">🛒</div>
              <p>购物车空空如也～去挑几件喜欢的吧</p>
            </div>
            <div class="cart-footer" v-if="cart.length > 0">
              <div class="cart-total">
                合计：<span class="total-num">💠{{ totalPrice }}</span>
                <span class="total-sub">（共 {{ cartCount }} 件）</span>
              </div>
              <el-button type="warning" round class="pay-btn" :loading="paying" @click="doBuy">立即购买 · 支付</el-button>
            </div>
          </el-tab-pane>

          <!-- 消费记录 -->
          <el-tab-pane label="消费记录" name="orders">
            <div class="order-list" v-if="orders.length > 0">
              <div class="order-card" v-for="o in orders" :key="o.order.id">
                <div class="order-head">
                  <span>订单 #{{ o.order.id }}</span>
                  <span class="order-time">{{ o.order.createTime }}</span>
                </div>
                <div class="order-item" v-for="it in o.items" :key="it.id">
                  <span>{{ it.productName }}</span>
                  <span>×{{ it.count }}</span>
                  <span>💠{{ it.price * it.count }}</span>
                </div>
                <div class="order-total">实付 💠{{ o.order.totalAmount }}</div>
              </div>
            </div>
            <div class="cart-empty" v-else>
              <div class="empty-icon">🧾</div>
              <p v-if="user && user.no">还没有消费记录～</p>
              <p v-else>登录后可查看消费记录</p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <!-- 支付成功弹窗 -->
    <el-dialog :visible.sync="successVisible" width="360px" custom-class="success-dialog" :close-on-click-modal="true">
      <div class="success-box">
        <div class="success-icon">✨</div>
        <h2>购买成功！</h2>
        <p class="success-order">订单号 #{{ lastOrderId }}，共支付 💠{{ lastTotal }}</p>
        <p class="success-remain">剩余星裙币：<b>💠{{ coin }}</b></p>
        <el-button type="primary" round @click="successVisible = false">收下啦</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 星物语小店（左右布局版）
 * - 左侧 1/4 栏：店名标题 / 星裙币余额 / 空白 / 当前时间
 * - 右侧 3/4 栏：商品列表，内部独立滚动（页面整体不滚动）
 * - 点击商品图片可放大预览，支持左右切换
 * - 购物车 / 支付购买 / 消费记录功能保留
 */
import HeaderNav from '../HeaderNav'
import bus from '../../utils/bus'
import { listProducts, getCoin, buy, getOrders } from '../../api/shop'

// 商品图片统一从 src/components/Storyshop/shop 目录打包加载（webpack require.context）
const shopImages = require.context('./shop', false, /\.(jpg|jpeg|png|gif)$/)

function resolveShopImg(file) {
  if (!file) return ''
  try {
    return shopImages('./' + file)
  } catch (e) {
    return ''
  }
}

const WEEK = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']

export default {
  name: 'Storyshop',
  components: { HeaderNav },
  data() {
    return {
      activeCategory: '全部',
      categories: [],
      products: [],
      loading: false,
      user: null,
      coin: 0,
      cart: [], // {id,name,price,image,count}
      cartVisible: false,
      cartTab: 'cart',
      paying: false,
      orders: [],
      successVisible: false,
      lastOrderId: null,
      lastTotal: 0,
      // 图片预览
      previewVisible: false,
      previewIndex: 0,
      // 当前时间
      now: '',
      today: '',
      week: '',
      timer: null
    }
  },
  computed: {
    roleName() {
      if (!this.user) return ''
      if (this.user.roleId === 0) return '超级管理员'
      if (this.user.roleId === 1) return '管理员'
      return '普通用户'
    },
    // 当前预览的商品
    previewProduct() {
      return this.products[this.previewIndex] || null
    },
    cartCount() {
      return this.cart.reduce((s, i) => s + i.count, 0)
    },
    totalPrice() {
      return this.cart.reduce((s, i) => s + this.itemFinalPrice(i) * i.count, 0)
    }
  },
  created() {
    this.restoreUser()
    this.loadCategories()
    this.loadProducts()
    this.startClock()
    // 登录/退出登录后（头部组件发起）同步当前页面登录态与余额
    bus.$on('music:user-changed', this.onUserChanged)
  },
  beforeDestroy() {
    bus.$off('music:user-changed', this.onUserChanged)
    this.stopClock()
  },
  methods: {
    // ===== 时间 =====
    startClock() {
      this.tick()
      this.timer = setInterval(this.tick, 1000)
    },
    stopClock() {
      if (this.timer) clearInterval(this.timer)
      this.timer = null
    },
    tick() {
      const d = new Date()
      const p = n => (n < 10 ? '0' + n : '' + n)
      this.now = p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
      this.today = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
      this.week = WEEK[d.getDay()]
    },

    // ===== 用户 / 余额 =====
    restoreUser() {
      const cu = sessionStorage.getItem('CurUser')
      if (cu) {
        try {
          this.user = JSON.parse(cu)
          if (this.user && this.user.no) this.refreshCoin()
          return
        } catch (e) {
          // 缓存解析失败，视为未登录
        }
      }
      // 关键：缓存不存在（已退出登录）时必须清空 user，否则残留登录态可继续购买
      this.user = null
    },
    refreshCoin() {
      getCoin(this.user.no).then(res => {
        if (res.code === 200) {
          this.coin = res.data.coin
        }
      }).catch(() => {})
    },
    onUserChanged() {
      this.restoreUser()
      this.cart = []
    },
    openLoginTip() {
      this.$message.warning('请先在右上角点击「登录」')
    },

    // ===== 商品 =====
    loadCategories() {
      this.$axios.get(this.$httpUrl + '/shop/category/list').then(res => res.data).then(res => {
        if (res.code === 200) {
          this.categories = res.data || []
        }
      }).catch(() => {})
    },
    // 是否在打折（1-9 折）
    isOnSale(p) {
      return p && p.discount && p.discount >= 1 && p.discount < 10
    },
    // 折后价（与原价一致格式）
    finalPrice(p) {
      if (!this.isOnSale(p)) return Number(p.price).toFixed(1)
      return (Number(p.price) * p.discount / 10).toFixed(1)
    },
    // 购物车条目折后价
    itemFinalPrice(item) {
      if (!this.isOnSale(item)) return Number(item.price).toFixed(1)
      return (Number(item.price) * item.discount / 10).toFixed(1)
    },
    loadProducts() {
      this.loading = true
      listProducts(this.activeCategory).then(res => {
        if (res.code === 200) {
          this.products = res.data || []
          // 切分类后若预览下标越界则重置
          if (this.previewIndex >= this.products.length) this.previewIndex = 0
        }
      }).catch(() => {
        this.$message.error('服务器连接异常，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    imgUrl(file) {
      return resolveShopImg(file)
    },
    imgErr(e) {
      e.target.src = resolveShopImg('p1.jpg')
    },

    // ===== 图片预览 =====
    openPreview(idx) {
      this.previewIndex = idx
      this.previewVisible = true
    },
    prevImg() {
      if (this.previewIndex > 0) this.previewIndex -= 1
    },
    nextImg() {
      if (this.previewIndex < this.products.length - 1) this.previewIndex += 1
    },

    // ===== 购物车 =====
    addToCart(p) {
      const hit = this.cart.find(i => i.id === p.id)
      if (hit) {
        hit.count += 1
      } else {
        this.cart.push({ id: p.id, name: p.name, price: Number(p.price), discount: p.discount || null, image: p.image, count: 1 })
      }
      this.$message.success(`已加入购物车：${p.name}`)
    },
    changeCount(idx, delta) {
      const item = this.cart[idx]
      item.count += delta
      if (item.count <= 0) {
        this.cart.splice(idx, 1)
      }
    },
    removeItem(idx) {
      this.cart.splice(idx, 1)
    },

    // ===== 支付 =====
    doBuy() {
      // 支付前实时核对登录态，避免退出后仍可购买
      let curUser = null
      const cu = sessionStorage.getItem('CurUser')
      if (cu) {
        try {
          curUser = JSON.parse(cu)
        } catch (e) {
          curUser = null
        }
      }
      if (!curUser || !curUser.no) {
        this.user = null
        this.$message.warning('请先登录后再购买')
        return
      }
      this.user = curUser
      if (this.cart.length === 0) return
      this.paying = true
      const items = this.cart.map(i => ({ productId: i.id, count: i.count }))
      buy({ no: curUser.no, items }).then(res => {
        if (res.code === 200) {
          this.lastOrderId = res.data.orderId
          this.lastTotal = res.data.total
          this.coin = res.data.remain
          // 回写余额前再核对一次：仍是同一账号登录时才更新缓存
          const now = sessionStorage.getItem('CurUser')
          if (now) {
            try {
              const nu = JSON.parse(now)
              if (nu.no === curUser.no) {
                nu.coin = res.data.remain
                sessionStorage.setItem('CurUser', JSON.stringify(nu))
                this.user = nu
              }
            } catch (e) {
              /* 忽略解析异常 */
            }
          }
          this.cart = []
          this.successVisible = true
          this.loadOrders()
        } else {
          this.$message.error(res.msg || '购买失败')
        }
      }).catch(err => {
        this.$message.error(err.message || '服务器连接异常，请稍后重试')
      }).finally(() => {
        this.paying = false
      })
    },
    loadOrders() {
      if (!this.user || !this.user.no) return
      getOrders(this.user.no).then(res => {
        if (res.code === 200) {
          this.orders = res.data || []
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
/* ===== 页面：整体不滚动，左右两栏填满 ===== */
.storyshop {
  height: 100vh;
  box-sizing: border-box;
  padding-top: 60px; /* 给固定导航让位 */
  display: flex;
  overflow: hidden;
  background: linear-gradient(180deg, #fff5fa 0%, #fdf6ff 55%, #eef7ff 100%);
}

/* ===== 左右布局 ===== */
.shop-layout {
  flex: 1;
  display: flex;
  min-height: 0;
  min-width: 0;
}

/* ===== 左侧栏（1/4） ===== */
.shop-sidebar {
  width: 15%;
  min-width: 180px;
  max-width: 300px;
  box-sizing: border-box;
  padding: 26px 22px 20px;
  display: flex;
  flex-direction: column;
  border-right: 2px dashed rgba(255, 170, 210, 0.5);
  background:
      radial-gradient(circle at 20% 10%, rgba(255, 214, 233, 0.6), transparent 45%),
      radial-gradient(circle at 90% 90%, rgba(194, 229, 255, 0.6), transparent 45%),
      linear-gradient(180deg, #ffeaf5, #fff5fb);
}

.side-block {
  box-sizing: border-box;
}

/* 区域1：小店名称 */
.side-title {
  text-align: center;
  padding: 6px 0 16px;
}

.shop-badge {
  display: inline-block;
  padding: 7px 22px;
  border-radius: 30px;
  background: linear-gradient(90deg, #ff8ec6, #a78bfa);
  color: #fff;
  font-size: 14px;
  letter-spacing: 2px;
  font-weight: bold;
  box-shadow: 0 6px 16px rgba(255, 142, 198, 0.4);
}

.shop-name {
  margin: 18px 0 10px;
  font-size: 24px;
  line-height: 1.5;
  color: #5c3a52;
  letter-spacing: 1px;
}

.shop-slogan {
  color: #a98f9f;
  font-size: 12px;
  line-height: 1.8;
}

/* 区域2：星裙币 */
.side-coin {
  margin-top: 8px;
  padding: 18px 16px;
  border-radius: 18px;
  background: linear-gradient(135deg, #fff0f7, #eef4ff);
  border: 2px solid rgba(255, 170, 210, 0.6);
  box-shadow: 0 8px 20px rgba(255, 160, 200, 0.22);
  text-align: center;
}

.coin-title {
  color: #b06a94;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 1px;
}

.coin-num {
  margin-top: 8px;
  font-size: 34px;
  font-weight: bold;
  color: #e0539c;
  text-shadow: 0 0 14px rgba(224, 83, 156, 0.35);
}

.coin-login {
  margin-top: 8px;
}

.coin-tip {
  margin-top: 8px;
  color: #b08aa0;
  font-size: 11px;
  line-height: 1.6;
}

.coin-user {
  margin-top: 8px;
  color: #8a6a80;
  font-size: 12px;
}

/* 区域3：空白占位（弹性撑开） */
.side-spacer {
  flex: 1;
}

/* 区域4：当前时间 */
.side-clock {
  padding: 14px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid #ffe0ee;
  text-align: center;
}

.clock-time {
  font-size: 30px;
  font-weight: bold;
  color: #5c3a52;
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
}

.clock-date {
  margin-top: 6px;
  font-size: 12px;
  color: #a98f9f;
}

/* ===== 右侧栏（3/4）：商品列表独立滚动 ===== */
.shop-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.35);
}

.main-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 24px 0;
}

.category-tabs :deep(.el-tabs__item) {
  font-size: 15px;
  font-weight: bold;
  color: #8a6a80;
}

.category-tabs :deep(.el-tabs__item.is-active) {
  color: #e0539c;
}

.category-tabs :deep(.el-tabs__active-bar) {
  background-color: #e0539c;
}

.product-count {
  color: #b08aa0;
  font-size: 12px;
}

/* 商品滚动区：只在这里滚动 */
.product-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 24px 90px;
  box-sizing: border-box;
}

.product-scroll::-webkit-scrollbar {
  width: 8px;
}

.product-scroll::-webkit-scrollbar-thumb {
  background: rgba(224, 83, 156, 0.35);
  border-radius: 4px;
}

/* ===== 商品卡片 ===== */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  min-height: 200px;
}

.product-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #ffe1ee;
  box-shadow: 0 8px 20px rgba(255, 180, 210, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 14px 28px rgba(255, 160, 200, 0.3);
}

/* 图片可点击放大 */
.product-img-wrap {
  position: relative;
  padding-top: 100%;
  background: linear-gradient(160deg, #fff0f6, #f3f6ff);
  cursor: zoom-in;
}

.product-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(92, 58, 82, 0.35);
  color: #fff;
  font-size: 13px;
  letter-spacing: 2px;
  opacity: 0;
  transition: opacity 0.25s;
}

.product-img-wrap:hover .img-mask {
  opacity: 1;
}

.category-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 3px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.92);
  color: #e0539c;
  font-size: 12px;
  font-weight: bold;
  border: 1px solid #ffd0e4;
}

.product-info {
  padding: 12px 14px 14px;
}

.product-name {
  margin: 0 0 5px;
  font-size: 18px;
  color: #5c3a52;
}

.product-desc {
  margin: 0 0 10px;
  font-size: 13px;
  color: #a98f9f;
  line-height: 1.6;
  height: 38px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  color: #e0539c;
  font-size: 19px;
  font-weight: bold;
}

.price b {
  margin-right: 3px;
}

/* 打折价：原价划线 + 现价 + 折扣角标 */
.price-origin {
  font-size: 12px;
  color: #b8a0aa;
  font-weight: normal;
  text-decoration: line-through;
  margin: 0 4px;
  font-style: normal;
}

.price-now {
  font-size: 19px;
  color: #e0539c;
}

.sale-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  font-size: 11px;
  font-style: normal;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(135deg, #ff6b9d, #e0539c);
  border-radius: 8px;
  vertical-align: 2px;
}

.price i {
  font-style: normal;
  font-size: 12px;
  color: #b08aa0;
  font-weight: normal;
}

.empty-tip {
  grid-column: 1 / -1;
  text-align: center;
  color: #b8a0b0;
  padding: 60px 0;
}

/* ===== 悬浮购物车 ===== */
.cart-fab {
  position: fixed;
  right: 28px;
  bottom: 40px;
  z-index: 990;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff8ec6, #a78bfa);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(255, 120, 190, 0.45);
  transition: transform 0.2s;
}

.cart-fab:hover {
  transform: scale(1.08);
}

.fab-icon {
  margin-top: 10px;
  font-size: 22px;
  line-height: 1;
}

.fab-count {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  padding: 0 5px;
  border-radius: 12px;
  background: #ff4d6d;
  font-size: 12px;
  text-align: center;
}

.fab-text {
  font-size: 11px;
  margin-top: 3px;
}

/* ===== 图片放大预览 ===== */
.preview-box {
  text-align: center;
}

.preview-img-wrap {
  position: relative;
}

.preview-img {
  width: 100%;
  max-height: 62vh;
  object-fit: contain;
  border-radius: 12px;
  background: linear-gradient(160deg, #fff0f6, #f3f6ff);
}

.preview-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #e0539c;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  user-select: none;
}

.preview-nav.prev {
  left: 8px;
}

.preview-nav.next {
  right: 8px;
}

.preview-nav.disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.preview-info {
  margin-top: 12px;
}

.preview-info h3 {
  margin: 0 0 6px;
  color: #5c3a52;
  font-size: 17px;
}

.preview-info p {
  margin: 0 0 8px;
  color: #a98f9f;
  font-size: 13px;
}

.preview-price {
  color: #e0539c;
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.preview-cat {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 20px;
  background: #fff0f7;
  color: #e0539c;
  font-size: 12px;
  border: 1px solid #ffd0e4;
}

/* ===== 购物车抽屉 ===== */
:deep(.shop-drawer) {
  background: linear-gradient(160deg, #fff5fa, #f2f8ff);
}

.drawer-inner {
  padding: 26px 22px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.shop-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.shop-tabs :deep(.el-tabs__content) {
  flex: 1;
  overflow-y: auto;
}

.shop-tabs :deep(.el-tabs__item.is-active) {
  color: #e0539c;
}

.shop-tabs :deep(.el-tabs__active-bar) {
  background-color: #e0539c;
}

.cart-list {
  padding: 4px 2px;
}

.cart-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px dashed #ffd8e8;
}

.cart-img {
  width: 74px;
  height: 74px;
  border-radius: 12px;
  object-fit: cover;
  border: 1px solid #ffe1ee;
  flex-shrink: 0;
}

.cart-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.cart-name {
  font-size: 14px;
  color: #5c3a52;
  font-weight: bold;
}

.cart-price {
  color: #e0539c;
  font-weight: bold;
  margin: 4px 0 8px;
}

.cart-ctrl {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cart-count {
  min-width: 24px;
  text-align: center;
  font-weight: bold;
  color: #5c3a52;
}

.cart-remove {
  margin-left: auto;
}

.cart-empty {
  text-align: center;
  color: #b8a0b0;
  padding: 70px 0;
}

.empty-icon {
  font-size: 52px;
  margin-bottom: 12px;
}

.cart-footer {
  padding-top: 16px;
  border-top: 1px solid #ffd8e8;
}

.cart-total {
  font-size: 14px;
  color: #8a6a80;
  margin-bottom: 12px;
  text-align: right;
}

.total-num {
  font-size: 24px;
  font-weight: bold;
  color: #e0539c;
}

.total-sub {
  font-size: 12px;
  color: #b08aa0;
}

.pay-btn {
  width: 100%;
  font-size: 16px;
  letter-spacing: 4px;
}

/* ===== 消费记录 ===== */
.order-list {
  padding: 4px 2px;
}

.order-card {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #ffe1ee;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.order-head {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #b08aa0;
  border-bottom: 1px dashed #ffe1ee;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.order-item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #6b4d61;
  padding: 3px 0;
}

.order-total {
  text-align: right;
  font-size: 13px;
  color: #e0539c;
  font-weight: bold;
  margin-top: 6px;
}

/* ===== 支付成功弹窗 ===== */
.success-box {
  text-align: center;
  padding: 10px 4px 4px;
}

.success-icon {
  font-size: 56px;
  animation: pop 0.5s ease;
}

.success-box h2 {
  margin: 12px 0 8px;
  color: #5c3a52;
  letter-spacing: 2px;
}

.success-order {
  color: #8a6a80;
  font-size: 13px;
  margin: 6px 0;
}

.success-remain {
  color: #8a6a80;
  font-size: 14px;
  margin-bottom: 18px;
}

.success-remain b {
  color: #e0539c;
}

@keyframes pop {
  0% { transform: scale(0.3); opacity: 0; }
  70% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}
</style>
